export default __webpack_public_path__ + "static/media/login.ecaf87a5.jpeg";